import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Row, Col, Alert, Spinner, Modal, ListGroup } from 'react-bootstrap';
import Header from '../../layouts/Header';
import { useDropzone } from 'react-dropzone';
import axios from '../../api/axios';
import Select from 'react-select';
import { toast } from 'react-toastify';
import jsPDF from 'jspdf';
import 'jspdf-autotable'
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { useSelector } from 'react-redux';
import makeAnimated from "react-select/animated";

const MenuPricing = () => {
    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    const accessToken = localStorage.getItem('authToken');
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [menuAccess, setMenuAccess] = useState([]);
    const [groupByCategory, setGroupByCategory] = useState(true);
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: '6px',
            minWidth: "200px",
            borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#80bdff" : "#ced4da",
            },
            fontSize: '13px'
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
            fontSize: '13px'
        }),
        menu: (provided) => ({
            ...provided,
            fontSize: '13px'
        }),
        option: (provided) => ({
            ...provided,
            fontSize: '13px'
        })
    };
    const animatedComponents = makeAnimated();

    const [bulkResult, setBulkResult] = useState(null);
    const [showResultModal, setShowResultModal] = useState(false);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("MenuPricing:")
            );
            setMenuAccess(filteredAccess);
        }
    }, [access]);

    console.log("Menu Access:", menuAccess);

    // States for Add functionality
    const [newPricing, setNewPricing] = useState({
        group: '',
        product: '',
        mrpPrice: '',
        offerPrice: '',
        isIntroductoryFlag: false
    });

    // States for Edit functionality
    const [editPricing, setEditPricing] = useState({
        _id: '',
        group: '',
        product: '',
        mrpPrice: '',
        offerPrice: '',
        isIntroductoryFlag: false
    });

    const [groups, setGroups] = useState([]);
    const [filteredProductList, setFilteredProductList] = useState([]);
    const [initialMenuPricings, setInitialMenuPricings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    // Modal states
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showBulkModal, setShowBulkModal] = useState(false);

    // State for bulk upload
    const [selectedGroup, setSelectedGroup] = useState('');
    const [selectedGroupName, setSelectedGroupName] = useState('');
    const [file, setFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [menuPricings, setMenuPricings] = useState([]);
    const [proccessing, setProccessing] = useState(false);
    const [selectedGroupFilter, setSelectedGroupFilter] = useState('');
    const [deleteGroupId, setDeleteGroupId] = useState('');
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [searchText, setSearchText] = useState('');

    const [categoryList, setCategoryList] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState('');

    const [excelBtnLoading, setExcelBtnLoading] = useState(false);
    const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);

    const [editingId, setEditingId] = useState(null);
    const [tempPricing, setTempPricing] = useState({
        mrpPrice: '',
        offerPrice: '',
        isIntroductoryFlag: false
    });

    const categoryOptions = categoryList.map((rm) => ({
        value: rm._id,
        label: rm.name,
    }));

    // Add these functions to your component
    const exportToPDF = () => {
        const doc = new jsPDF();

        // Add title
        doc.setFontSize(18);
        doc.text('Menu Pricing Report', 14, 20);

        // Get current date
        const date = new Date().toLocaleDateString();
        doc.setFontSize(10);
        doc.text(`Generated on: ${date}`, 14, 28);

        // Prepare data for the table
        const tableData = menuPricings?.map((item, index) => [
            index + 1,
            item?.group?.groupName,
            item?.group?._id,
            item?.product?.name,
            item?.product?._id,
            item?.product?.category?.name,
            item?.product?.foodType,
            `₹${item?.mrpPrice?.toFixed(2)}`,
            `₹${item?.offerPrice?.toFixed(2)}`,
            item?.isIntroductoryFlag ? 'Yes' : 'No'
        ]);

        // Add table
        doc.autoTable({
            head: [['#', 'Group', 'Product', 'Type', 'MRP Price', 'Offer Price', 'Category', 'Introductory']],
            body: tableData,
            startY: 35,
            styles: {
                fontSize: 8,
                cellPadding: 2,
            },
            headStyles: {
                fillColor: [41, 128, 185],
                textColor: 255,
                fontStyle: 'bold'
            },
            columnStyles: {
                0: { cellWidth: 10 },
                1: { cellWidth: 30 },
                2: { cellWidth: 40 },
                3: { cellWidth: 20 },
                4: { cellWidth: 20 },
                5: { cellWidth: 20 },
                6: { cellWidth: 30 }
            }
        });

        // Save the PDF
        doc.save('menu_pricing_report.pdf');
    };

    const groupProductsByCategory = (products) => {
        if (!groupByCategory) return { 'All Products': products };

        return products.reduce((acc, item) => {
            const categoryName = item?.product?.category?.name || 'Uncategorized';
            if (!acc[categoryName]) {
                acc[categoryName] = [];
            }
            acc[categoryName].push(item);
            return acc;
        }, {});
    };

    const exportToExcel = (groupName = 'All Groups') => {
        setExcelBtnLoading(true);
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Menu Pricing');

        // Add main title (merged cells)
        worksheet.mergeCells('A1:H1');
        const titleRow = worksheet.getCell('A1');
        titleRow.value = `Menu Pricing Report - ${menuPricings[0]?.group?.groupName}`;
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center' };

        // Add subtitle with date (merged cells)
        worksheet.mergeCells('A2:H2');
        const dateRow = worksheet.getCell('A2');
        dateRow.value = `Generated on: ${new Date().toLocaleDateString()}`;
        dateRow.font = { italic: true, size: 10 };
        dateRow.alignment = { horizontal: 'center' };

        // Add headers
        const headers = ['#', 'Group', 'GroupId', 'Product', 'ProductId', 'Category', 'Type', 'MRP Price (₹)', 'Offer Price (₹)', 'Introduced Price'];
        const headerRow = worksheet.addRow(headers);

        // Style headers
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF2980B9' }
            };
            cell.font = {
                bold: true,
                color: { argb: 'FFFFFFFF' },
                size: 11
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
            cell.alignment = { horizontal: 'center' };
        });

        // Add data
        menuPricings?.forEach((item, index) => {
            const row = worksheet.addRow([
                index + 1,
                item?.group?.groupName || '-',
                item?.group?._id || '-',
                item?.product?.name || '-',
                item?.product?._id || '-',
                item?.product?.category?.name || '-',
                item?.product?.foodType || '-',
                Number(item?.mrpPrice?.toFixed(2)) || 0,
                Number(item?.offerPrice?.toFixed(2)) || 0,
                item?.isIntroductoryFlag ? 'Yes' : 'No'
            ]);

            // Style data rows
            row.eachCell((cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
                cell.font = { size: 10 };

                // Format price columns with ₹ symbol
                if (colNumber === 8 || colNumber === 9) {
                    cell.numFmt = '"₹"#,##0.00';
                }

                // Alternate row colors
                if (index % 2 === 0) {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF8F9FA' }
                    };
                }
            });
        });

        // Set column widths
        worksheet.columns = [
            { width: 5 },  // #
            { width: 20 }, // Group
            { width: 30 }, // GroupId
            { width: 30 }, // Product
            { width: 40 }, // ProductId
            { width: 20 }, // Category
            { width: 15 }, // Type
            { width: 15 }, // MRP Price
            { width: 15 }, // Offer Price
            { width: 15 }  // Introductory
        ];

        // Generate and download Excel file
        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `menu_pricing_report_.xlsx`;
            link.click();
        });
        setExcelBtnLoading(false);
    };

    const handleDownloadExcel = () => {
        setDownloadBtnLoading(true);
        getMenuPricings(selectedGroupFilter, selectedCategoryId, true);
    };

    const getMenuPricings = async (id, catId, download) => {
        setProccessing(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            let params = `menu-product-pricing?group=${id}`;

            if (catId !== "all") {
                params += `&categoryId=${catId}`
            }

            if (download) {
                params += `&isDownload=${download}`
            }

            const response = await axios.get(params, {
                headers,
                responseType: download ? "blob" : "json"
            });

            if (download) {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                const url = window.URL.createObjectURL(blob);
                console.log("Download Url Log :", url);

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Menu Pricing Of the Group ${selectedGroupName}.xlsx`);
                document.body.appendChild(link);
                link.click();

                // Clean up
                link.remove();
                window.URL.revokeObjectURL(url);

                toast.success('Excel file downloaded successfully!', {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light"
                });
            } else {
                console.log("Menu Pricing List :", response?.data?.data?.menuGroup);
                let FilteredPricing = response?.data?.data?.menuGroup?.filter(mp => mp.product?.isDelete === false);
                console.log("Filtered Pricing List :", FilteredPricing);
                setInitialMenuPricings(FilteredPricing);
                setMenuPricings(FilteredPricing);
            }
        } catch (error) {
            console.log("Error in Menu Pricing Api:", error);
        } finally {
            setProccessing(false);
            setDownloadBtnLoading(false);
        }
    };

    const getCategoryList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("masters/category/get", { headers });

            if (response?.data?.status === true) {
                setCategoryList(response?.data?.data?.categories);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getProductsList = async (id) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("product", { headers });
            if (response?.data?.status === true) {
                let filterPro = response?.data?.data?.products;
                setFilteredProductList(filterPro);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const getMenuGroup = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("menu-group", { headers });
            if (response?.data?.status === true) {
                setGroups(response?.data?.data?.menuGroup);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleCloseAddModal = () => {
        setShowAddModal(false);
        setNewPricing({
            group: '',
            product: '',
            mrpPrice: '',
            offerPrice: '',
            isIntroductoryFlag: false
        });
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setEditPricing({
            _id: '',
            group: '',
            product: '',
            mrpPrice: '',
            offerPrice: '',
            isIntroductoryFlag: false
        });
    };

    const handleCloseBulkModal = () => {
        setShowBulkModal(false);
        setSelectedGroup('');
        setFile(null);
    }

    const handleAddInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setNewPricing(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleEditInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setEditPricing(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleAddSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setSuccessMessage('');
        setErrorMessage('');

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };
            const response = await axios.post('menu-product-pricing?_single=true', newPricing, { headers });

            toast.success(response?.data?.data?.message, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });

            setNewPricing({
                group: '',
                product: '',
                mrpPrice: '',
                offerPrice: '',
                isIntroductoryFlag: false
            });
            getMenuPricings(selectedGroupFilter);
            setShowAddModal(false);
        } catch (error) {
            console.log("HEllo", error);

            handleApiError(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setSuccessMessage('');
        setErrorMessage('');

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };
            const response = await axios.put(
                `menu-product-pricing?_single=true&_id=${editPricing._id}`,
                editPricing,
                { headers }
            );

            toast.success(response?.data?.data?.message, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
            getMenuPricings(selectedGroupFilter);
            setEditPricing({
                _id: '',
                group: '',
                product: '',
                mrpPrice: '',
                offerPrice: '',
                isIntroductoryFlag: false
            });
            setShowEditModal(false);
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleApiError = (error) => {
        console.log("Error :", error);

        if (error?.response) {
            let errorMessage = '';
            if (error.response?.status === 406) {
                errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
            }
            else if (error.response?.status === 412) {
                errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 400) {
                errorMessage = error?.response?.data?.message || error?.response?.data?.error;
            } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error;
            } else if (error?.response?.status === 404) {
                errorMessage = error?.response?.data?.error;
            }

            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        }
    };

    // Bulk upload functions
    const { getRootProps, getInputProps } = useDropzone({
        accept: '.xlsx, .xls',
        maxFiles: 1,
        onDrop: acceptedFiles => {
            setFile(acceptedFiles[0]);
        }
    });

    const handleBulkSubmit = async () => {
        if (!file) {
            setErrorMessage('Please select a group and upload a file');
            return;
        }

        setUploading(true);
        setErrorMessage('');

        const formData = new FormData();
        formData.append('file', file);

        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
            };

            const response = await axios.put('menu-product-pricing/bulkprice', formData,
                {
                    headers,
                    onUploadProgress: progressEvent => {
                        const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(progress);
                    }
                }
            );

            console.log("Response :", response);

            const data = response?.data;

            if (data?.errors?.length || data?.duplicates?.length || data?.skippedCount > 0) {
                // Show modal with details
                setBulkResult(data);
                setShowResultModal(true);
            } else {
                // Show success toast
                toast.success(data?.message || "Bulk update completed.", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }

            setFile(null);
            setSelectedGroup('');
            getMenuPricings(selectedGroupFilter);
            setShowBulkModal(false);

        } catch (error) {
            console.log("Error in bulk price update :", error);
            handleApiError(error);
        } finally {
            setUploading(false);
            setUploadProgress(0);
        }
    };

    const handleSelectedGroupFilterChange = (e) => {
        let pricingID = e.target.value;
        console.log("E.TARGET :", e);

        setSelectedGroupFilter(e.target.value);
        setSelectedGroupName(e.target.selectedOptions[0].label);
        getMenuPricings(pricingID, selectedCategoryId);
    };

    const handleSelectedCategoryFilterChange = (selectedOption) => {
        const catId = selectedOption ? selectedOption.value : 'all';
        setSelectedCategoryId(catId);
        getMenuPricings(selectedGroupFilter, catId);
    };

    const handleOpenDeleteModal = (data) => {
        console.log("Data to be deleted :", data);

        setDeleteGroupId(data?._id)
        setOpenDeleteModal(true);
    };

    const handleDelete = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                _id: deleteGroupId,
            };

            const response = await axios.delete(`menu-product-pricing`, { data, headers });
            console.log("Response :", response);
            getMenuPricings(selectedGroupFilter);
            toast.success(response?.data?.data?.message, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
            setOpenDeleteModal(false);
        } catch (error) {
            if (error.response.status === 403) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response.status === 404) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response.status === 406) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response.status === 412) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const handleUpdatePricing = async (id, groupId, productId) => {
        setIsLoading(true);
        setSuccessMessage('');
        setErrorMessage('');

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };

            const response = await axios.put(
                `menu-product-pricing?_single=true&_id=${id}`,
                {
                    _id: id,
                    group: groupId,
                    product: productId,
                    mrpPrice: tempPricing.mrpPrice,
                    offerPrice: tempPricing.offerPrice,
                    isIntroductoryFlag: tempPricing.isIntroductoryFlag
                },
                { headers }
            );

            toast.success(response?.data?.data?.message, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });

            getMenuPricings(selectedGroupFilter, selectedCategoryId);
            setEditingId(null);
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getProductsList();
        getMenuGroup();
        getCategoryList();
    }, []);

    useEffect(() => {
        const result = initialMenuPricings?.filter((item) => {
            return item?.product?.name?.toLowerCase().match(searchText.toLocaleLowerCase());
        });
        setMenuPricings(result);
    }, [searchText]);

    useEffect(() => {
        if (selectedGroupFilter === "") {
            setSearchText(""); // Clear the input when disabled
        }
    }, [selectedGroupFilter]);

    useEffect(() => {
        setSelectedCategoryId("");
    }, [!selectedGroupFilter])

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
                    <Row className="pt-4">
                        <Col>
                            <h5 className="fw-semibold" style={{ fontSize: "18px" }}>MENU PRICING MANAGEMENT</h5>
                        </Col>
                        <hr />
                    </Row>

                    <Row className='justify-content-between mt-2'>
                        <Col>
                            <Form.Select
                                name="groupName"
                                value={selectedGroupFilter}
                                onChange={handleSelectedGroupFilterChange}
                                required
                                style={{ fontSize: "13px" }}
                            >
                                <option value="">Select Menu Group</option>
                                {groups.map(group => (
                                    <option key={group._id} value={group._id} label={group?.groupName}>{group.groupName}</option>
                                ))}
                            </Form.Select>
                        </Col>

                        <Col md={4} lg={3}>
                            <Select
                                name="categoryFilter"
                                options={[
                                    { value: 'all', label: 'Category' },
                                    ...categoryOptions
                                ]}
                                value={
                                    categoryOptions.find((opt) => opt.value === selectedCategoryId) ||
                                    { value: 'all', label: 'Category' }
                                }
                                onChange={(selectedOption) => handleSelectedCategoryFilterChange(selectedOption)}
                                isDisabled={!selectedGroupFilter}
                                placeholder="Select Category"
                                styles={customStyles}
                                isClearable
                            />
                        </Col>

                        <Col lg="3">
                            <div className="input-group w-100">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search for products..."
                                    value={searchText}
                                    disabled={selectedGroupFilter === ""}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    style={{ fontSize: "13px" }}
                                />
                                <button className="btn btn-primary btn-sm" type="button" style={{ fontSize: "13px", padding: "0.25rem 0.5rem" }}>
                                    <i className="ri-search-line"></i>
                                </button>
                            </div>
                        </Col>

                        <Col lg="3" className="d-flex justify-content-end flex-column">
                            {(menuAccess.includes("MenuPricing:add") || email === "contact@xpansecafe.com") && (
                                <Button
                                    variant="primary"
                                    size="sm"
                                    className="fw-semibold"
                                    onClick={() => setShowAddModal(true)}
                                    style={{ fontSize: "13px", padding: "0.375rem 0.75rem" }}
                                >
                                    <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                    Add New Pricing
                                </Button>
                            )}
                        </Col>

                    </Row>

                    <Row className="mt-4 mb-2">
                        <Col>
                            <Card className="shadow-sm mb-4">
                                <Card.Header className="bg-white">
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <div>
                                            <h5 className="mb-0 fw-semibold" style={{ fontSize: "16px" }}>Menu Pricing List</h5>
                                        </div>
                                        <div>
                                            <Button
                                                variant="outline-success"
                                                size="sm"
                                                onClick={handleDownloadExcel}
                                                className="me-2"
                                                disabled={!selectedGroupFilter || menuPricings.length === 0}
                                                style={{ fontSize: "12px", padding: "0.25rem 0.5rem" }}
                                            >
                                                <i className="ri-file-excel-2-line me-1"></i>
                                                {excelBtnLoading ? <Spinner size='sm' /> : 'Export to Excel'}
                                            </Button>
                                            {(menuAccess.includes("MenuPricing:update") || email === "contact@xpansecafe.com") && (
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    className="fw-semibold"
                                                    onClick={() => setShowBulkModal(true)}
                                                    style={{ fontSize: "12px", padding: "0.25rem 0.5rem" }}
                                                >
                                                    <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                                    Bulk Update Pricing
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    {proccessing ? (
                                        <div className="text-center py-4">
                                            <Spinner animation="border" variant="primary" />
                                        </div>
                                    ) : (
                                        <>
                                            {/* Toggle button for category grouping */}
                                            {/* {selectedGroupFilter && menuPricings?.length > 0 && (
                <div className="mb-3 d-flex justify-content-end">
                    <Button
                        variant={groupByCategory ? "primary" : "outline-primary"}
                        size="sm"
                        onClick={() => setGroupByCategory(!groupByCategory)}
                        style={{ fontSize: "12px" }}
                    >
                        <i className={`ri-${groupByCategory ? 'list' : 'folder'}-line me-1`}></i>
                        {groupByCategory ? 'Show All' : 'Group by Category'}
                    </Button>
                </div>
            )} */}

                                            <div className="table-responsive">
                                                {(menuAccess.includes("MenuPricing:get") || email === "contact@xpansecafe.com") && (
                                                    <>
                                                        {!selectedGroupFilter ? (
                                                            <table className="table table-hover table-sm">
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan="9" className="text-center py-4">
                                                                            <div className="d-flex flex-column align-items-center">
                                                                                <i className="ri-information-line fs-1 text-muted mb-2"></i>
                                                                                <h5 className="text-muted" style={{ fontSize: "14px" }}>Please select a group to see product pricings</h5>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        ) : menuPricings?.length === 0 ? (
                                                            <table className="table table-hover table-sm">
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan="9" className="text-center py-4">
                                                                            <div className="d-flex flex-column align-items-center">
                                                                                <i className="ri-database-2-line fs-1 text-muted mb-2"></i>
                                                                                <h5 className="text-muted" style={{ fontSize: "14px" }}>No pricing data found</h5>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        ) : (
                                                            Object.entries(groupProductsByCategory(menuPricings)).map(([categoryName, items], categoryIndex) => (
                                                                <div key={categoryIndex} className="mb-4">
                                                                    {groupByCategory && (
                                                                        <div
                                                                            className="px-2 py-1 mb-3 rounded-1 d-flex justify-content-between align-items-center shadow-sm"
                                                                            style={{
                                                                                background: "linear-gradient(135deg, #4f46e5, #6366f1)",
                                                                                border: "1px solid rgba(255,255,255,0.15)",
                                                                            }}
                                                                        >
                                                                            <h6
                                                                                className="mb-0 fw-bold d-flex align-items-center"
                                                                                style={{
                                                                                    fontSize: "14px",
                                                                                    color: "#fff",
                                                                                    letterSpacing: "0.3px",
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className="ri-folder-line me-2"
                                                                                    style={{
                                                                                        fontSize: "18px",
                                                                                        color: "#c7d2fe",
                                                                                    }}
                                                                                ></i>
                                                                                {categoryName}
                                                                            </h6>

                                                                            <span
                                                                                className="badge rounded-3 px-3 py-2"
                                                                                style={{
                                                                                    background: "rgba(255,255,255,0.18)",
                                                                                    color: "#fff",
                                                                                    backdropFilter: "blur(4px)",
                                                                                    fontSize: "11px",
                                                                                    fontWeight: "600",
                                                                                    border: "1px solid rgba(255,255,255,0.2)",
                                                                                }}
                                                                            >
                                                                                {items.length} {items.length === 1 ? "item" : "items"}
                                                                            </span>
                                                                        </div>
                                                                    )}

                                                                    <table className="table table-hover table-sm mb-0">
                                                                        <thead>
                                                                            <tr style={{ fontSize: "13px" }}>
                                                                                <th>Sr.no</th>
                                                                                <th>Group</th>
                                                                                <th>Product</th>
                                                                                <th>Image</th>
                                                                                <th>Type</th>
                                                                                <th>MRP Price</th>
                                                                                <th>Offer Price</th>
                                                                                <th className='text-center'>Introduced Price</th>
                                                                                {((menuAccess.includes("MenuPricing:update") || menuAccess.includes("MenuPricing:delete")) || email === "contact@xpansecafe.com") && (
                                                                                    <th>Actions</th>
                                                                                )}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody style={{ fontSize: "12px" }}>
                                                                            {items.map((item, index) => (
                                                                                <tr key={item._id}>
                                                                                    <td style={{ fontSize: "12px" }}>
                                                                                        {groupByCategory ? index + 1 : menuPricings.indexOf(item) + 1}
                                                                                    </td>
                                                                                    <td style={{ fontSize: "12px" }}>
                                                                                        <strong className='text-muted'>{item?.group?.groupName}</strong>
                                                                                        <div className="text-muted small" style={{ fontSize: "11px" }}>{item?.group?.description}</div>
                                                                                    </td>
                                                                                    <td style={{ fontSize: "12px" }}>
                                                                                        <div className='fw-semibold'>{item?.product?.name}</div>
                                                                                        {!groupByCategory && (
                                                                                            <div className="text-muted small" style={{ fontSize: "11px" }}>{item?.product?.category?.name}</div>
                                                                                        )}
                                                                                    </td>
                                                                                    <td>
                                                                                        <img
                                                                                            src={item?.product?.displayImage}
                                                                                            alt={item?.product?.name}
                                                                                            style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px' }}
                                                                                        />
                                                                                    </td>
                                                                                    <td style={{ fontSize: "12px" }}>
                                                                                        <span className={`badge ${item?.product?.foodType === 'VEG' ? 'bg-success' :
                                                                                            item?.product?.foodType === 'NON-VEG' ? 'bg-danger' : 'bg-secondary'
                                                                                            }`} style={{ fontSize: "10px" }}>
                                                                                            {item?.product?.foodType}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td style={{ fontSize: "12px" }}>
                                                                                        {editingId === item._id ? (
                                                                                            <Form.Control
                                                                                                type="number"
                                                                                                min={0}
                                                                                                value={tempPricing.mrpPrice}
                                                                                                onChange={(e) => setTempPricing({ ...tempPricing, mrpPrice: e.target.value })}
                                                                                                className="w-100"
                                                                                                disabled={item?.product?.isFreebieProduct}
                                                                                                style={{ fontSize: "12px", padding: "0.25rem 0.5rem", height: "auto" }}
                                                                                            />
                                                                                        ) : (
                                                                                            <span className="text-danger fw-bold">₹{item?.mrpPrice}</span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td style={{ fontSize: "12px" }}>
                                                                                        {editingId === item._id ? (
                                                                                            <Form.Control
                                                                                                type="number"
                                                                                                min={0}
                                                                                                value={tempPricing.offerPrice}
                                                                                                onChange={(e) => setTempPricing({ ...tempPricing, offerPrice: e.target.value })}
                                                                                                className="w-100"
                                                                                                disabled={item?.product?.isFreebieProduct}
                                                                                                style={{ fontSize: "12px", padding: "0.25rem 0.5rem", height: "auto" }}
                                                                                            />
                                                                                        ) : (
                                                                                            <span className="text-success fw-bold">₹{item?.offerPrice}</span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td className='text-center'>
                                                                                        {editingId === item._id ? (
                                                                                            <Form.Check
                                                                                                type="checkbox"
                                                                                                checked={tempPricing.isIntroductoryFlag}
                                                                                                onChange={(e) => setTempPricing({
                                                                                                    ...tempPricing,
                                                                                                    isIntroductoryFlag: e.target.checked
                                                                                                })}
                                                                                                disabled={item?.product?.isFreebieProduct}
                                                                                                style={{ fontSize: "12px" }}
                                                                                            />
                                                                                        ) : (
                                                                                            <Form.Check
                                                                                                type="checkbox"
                                                                                                checked={item?.isIntroductoryFlag || false}
                                                                                                readOnly
                                                                                                disabled
                                                                                                style={{ fontSize: "12px" }}
                                                                                            />
                                                                                        )}
                                                                                    </td>
                                                                                    {((menuAccess.includes("MenuPricing:update") || menuAccess.includes("MenuPricing:delete")) || email === "contact@xpansecafe.com") && (
                                                                                        <td>
                                                                                            <div className='d-flex'>
                                                                                                {editingId === item._id ? (
                                                                                                    <>
                                                                                                        <Button
                                                                                                            variant="outline-success"
                                                                                                            size="sm"
                                                                                                            onClick={() => handleUpdatePricing(item._id, item?.group?._id, item?.product?._id)}
                                                                                                            style={{ marginRight: '8px', fontSize: "11px", padding: "0.2rem 0.4rem" }}
                                                                                                            disabled={isLoading || item?.product?.isFreebieProduct}
                                                                                                        >
                                                                                                            {isLoading ? 'Updating...' : 'Update'}
                                                                                                        </Button>
                                                                                                        <Button
                                                                                                            variant="outline-secondary"
                                                                                                            size="sm"
                                                                                                            onClick={() => setEditingId(null)}
                                                                                                            disabled={isLoading}
                                                                                                            style={{ fontSize: "11px", padding: "0.2rem 0.4rem" }}
                                                                                                        >
                                                                                                            Cancel
                                                                                                        </Button>
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        {(menuAccess.includes("MenuPricing:update") || email === "contact@xpansecafe.com") && (
                                                                                                            <Button
                                                                                                                variant="outline-primary"
                                                                                                                size="sm"
                                                                                                                onClick={() => {
                                                                                                                    setEditingId(item._id);
                                                                                                                    setTempPricing({
                                                                                                                        mrpPrice: item.mrpPrice,
                                                                                                                        offerPrice: item.offerPrice,
                                                                                                                        isIntroductoryFlag: item.isIntroductoryFlag || false
                                                                                                                    });
                                                                                                                }}
                                                                                                                style={{ marginRight: '8px', fontSize: "11px", padding: "0.2rem 0.4rem" }}
                                                                                                            >
                                                                                                                Edit
                                                                                                            </Button>
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </div>
                                                                                        </td>
                                                                                    )}
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            ))
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>

                {successMessage && (
                    <Alert variant="success" onClose={() => setSuccessMessage('')} dismissible style={{ fontSize: "13px" }}>
                        {successMessage}
                    </Alert>
                )}

                {errorMessage && (
                    <Alert variant="danger" onClose={() => setErrorMessage('')} dismissible style={{ fontSize: "13px" }}>
                        {errorMessage}
                    </Alert>
                )}

                {/* Add Pricing Modal */}
                <Modal show={showAddModal} onHide={handleCloseAddModal} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: "18px" }}>Add New Product Pricing</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleAddSubmit}>
                            <Row>
                                <Col md="6" lg="6">
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-semibold' style={{ fontSize: "13px" }}>Menu Group <span className='text-danger'>*</span></Form.Label>
                                        <Form.Select
                                            name="group"
                                            value={newPricing.group}
                                            onChange={handleAddInputChange}
                                            required
                                            style={{ fontSize: "13px" }}
                                        >
                                            <option value="">Select Menu Group</option>
                                            {groups.map(group => (
                                                <option key={group._id} value={group._id}>{group.groupName}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md="6" lg="6">
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-semibold' style={{ fontSize: "13px" }}>Product <span className='text-danger'>*</span></Form.Label>
                                        <Select
                                            options={filteredProductList?.map((rm) => ({
                                                value: rm?._id,
                                                label: rm?.name,
                                            }))}
                                            value={
                                                newPricing.product
                                                    ? {
                                                        value: newPricing?.product,
                                                        label: filteredProductList?.find(
                                                            (rm) => rm._id === newPricing?.product
                                                        )?.name,
                                                    }
                                                    : null
                                            }
                                            onChange={(selectedOption) => {
                                                handleAddInputChange({
                                                    target: {
                                                        name: "product",
                                                        value: selectedOption ? selectedOption.value : "",
                                                    },
                                                });
                                            }}
                                            classNamePrefix="react-select"
                                            isClearable
                                            placeholder="Select Menu"
                                            styles={customStyles}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md="6" lg="6">
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-semibold' style={{ fontSize: "13px" }}>MRP Price </Form.Label>
                                        <Form.Control
                                            min={0}
                                            type="number"
                                            placeholder='MRP Price'
                                            name="mrpPrice"
                                            value={newPricing.mrpPrice}
                                            onChange={handleAddInputChange}
                                            required
                                            style={{ fontSize: "13px" }}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md="6" lg="6">
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-semibold' style={{ fontSize: "13px" }}>Offer Price</Form.Label>
                                        <Form.Control
                                            min={0}
                                            type="number"
                                            placeholder='Offer Price'
                                            name="offerPrice"
                                            value={newPricing.offerPrice}
                                            onChange={handleAddInputChange}
                                            required
                                            style={{ fontSize: "13px" }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md="12">
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            id="addIntroductoryFlag"
                                            label="This is an Introductory Product"
                                            name="isIntroductoryFlag"
                                            checked={newPricing.isIntroductoryFlag}
                                            onChange={handleAddInputChange}
                                            style={{ fontSize: "13px" }}
                                        />
                                        <Form.Text className="text-muted" style={{ fontSize: "12px" }}>
                                            Check this if the product is being offered at an introductory price
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={handleCloseAddModal}
                            disabled={isLoading}
                            size="sm"
                            style={{ fontSize: "13px" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleAddSubmit}
                            disabled={isLoading}
                            size="sm"
                            style={{ fontSize: "13px" }}
                        >
                            {isLoading ? (
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                    {' '}Adding...
                                </>
                            ) : 'Add Pricing'}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Edit Pricing Modal */}
                <Modal show={showEditModal} onHide={handleCloseEditModal} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: "18px" }}>Edit Product Pricing</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleEditSubmit}>
                            <Row>
                                <Col md="6" lg="6">
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-semibold' style={{ fontSize: "13px" }}>Menu Group</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={groups.find(g => g._id === editPricing.group)?.groupName || ''}
                                            readOnly
                                            style={{ fontSize: "13px" }}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md="6" lg="6">
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-semibold' style={{ fontSize: "13px" }}>Product</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={filteredProductList.find(p => p._id === editPricing.product)?.name || ''}
                                            readOnly
                                            style={{ fontSize: "13px" }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md="6" lg="6">
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-semibold' style={{ fontSize: "13px" }}>MRP Price <span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            min={0}
                                            type="number"
                                            placeholder='MRP Price'
                                            name="mrpPrice"
                                            value={editPricing.mrpPrice}
                                            onChange={handleEditInputChange}
                                            required
                                            style={{ fontSize: "13px" }}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md="6" lg="6">
                                    <Form.Group className="mb-3">
                                        <Form.Label className='fw-semibold' style={{ fontSize: "13px" }}>Offer Price <span className='text-danger'>*</span></Form.Label>
                                        <Form.Control
                                            min={0}
                                            type="number"
                                            placeholder='Offer Price'
                                            name="offerPrice"
                                            value={editPricing.offerPrice}
                                            onChange={handleEditInputChange}
                                            required
                                            style={{ fontSize: "13px" }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col md="12">
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            id="editIntroductoryFlag"
                                            label="This is an Introductory Product"
                                            name="isIntroductoryFlag"
                                            checked={editPricing.isIntroductoryFlag}
                                            onChange={handleEditInputChange}
                                            style={{ fontSize: "13px" }}
                                        />
                                        <Form.Text className="text-muted" style={{ fontSize: "12px" }}>
                                            Check this if the product is being offered at an introductory price
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={handleCloseEditModal}
                            disabled={isLoading}
                            size="sm"
                            style={{ fontSize: "13px" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleEditSubmit}
                            disabled={isLoading}
                            size="sm"
                            style={{ fontSize: "13px" }}
                        >
                            {isLoading ? (
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                    {' '}Updating...
                                </>
                            ) : 'Update Pricing'}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Bulk Upload Modal */}
                <Modal show={showBulkModal} onHide={handleCloseBulkModal} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: "18px" }}>Bulk Pricing Update</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Label className='fw-semibold' style={{ fontSize: "13px" }}>Drop Excel File <span className='text-danger'>*</span> <span style={{ color: 'purple', fontSize: '11px' }}>(Step 1: Download the Excel file. Step 2: Upload the same file with updated prices here.)</span></Form.Label>
                        <div {...getRootProps({ className: 'dropzone mb-3 p-4 border rounded text-center' })} style={{ cursor: 'pointer', fontSize: "13px" }}>
                            <input {...getInputProps()} />
                            {file ? (
                                <div>
                                    <p style={{ fontSize: "13px" }}>Selected file: {file.name}</p>
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setFile(null);
                                        }}
                                        style={{ fontSize: "12px" }}
                                    >
                                        Remove File
                                    </Button>
                                </div>
                            ) : (
                                <p style={{ fontSize: "13px" }}>Drag & drop an Excel file here, or click to select</p>
                            )}
                        </div>

                        {uploadProgress > 0 && (
                            <div className="mb-3">
                                <div className="d-flex justify-content-between mb-1">
                                    <span style={{ fontSize: "12px" }}>Upload Progress:</span>
                                    <span style={{ fontSize: "12px" }}>{uploadProgress}%</span>
                                </div>
                                <div className="progress">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        style={{ width: `${uploadProgress}%` }}
                                        aria-valuenow={uploadProgress}
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={handleCloseBulkModal}
                            disabled={uploading}
                            size="sm"
                            style={{ fontSize: "13px" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleBulkSubmit}
                            disabled={!file || uploading}
                            size="sm"
                            style={{ fontSize: "13px" }}
                        >
                            {uploading ? (
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                    {' '}Uploading...
                                </>
                            ) : 'Upload & Update'}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Delete Modal */}
                {openDeleteModal ? (
                    <Modal show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title style={{ fontSize: "18px" }}>Confirm Delete</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ fontSize: "13px" }}>
                            Are you sure you want to delete this Menu Pricing? This action cannot be undone.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setOpenDeleteModal(false)} size="sm" style={{ fontSize: "13px" }}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={handleDelete} size="sm" style={{ fontSize: "13px" }}>
                                {isDeleteBtnLoading ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> :
                                    "Delete Product"
                                }
                            </Button>
                        </Modal.Footer>
                    </Modal>
                ) : null}

                {/* Show Bulk Price Updated Result Modal */}
                {showResultModal && (
                    <Modal
                        show={showResultModal}
                        onHide={() => setShowResultModal(false)}
                        size="lg"
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title style={{ fontSize: "18px" }}>📊 Bulk Upload Result</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="mb-3">
                                <h6 className="mb-2" style={{ fontSize: "14px" }}>
                                    <strong>Summary</strong>
                                </h6>
                                <div className="d-flex flex-wrap gap-2">
                                    <span className="badge bg-success" style={{ fontSize: "11px" }}>
                                        ✅ Updated: {bulkResult?.updatedCount}
                                    </span>
                                    <span className="badge bg-secondary" style={{ fontSize: "11px" }}>
                                        ⏭️ Skipped: {bulkResult?.skippedCount}
                                    </span>
                                    {bulkResult?.errors?.length > 0 && (
                                        <span className="badge bg-danger" style={{ fontSize: "11px" }}>
                                            ❌ Errors: {bulkResult.errors.length}
                                        </span>
                                    )}
                                    {bulkResult?.duplicates?.length > 0 && (
                                        <span className="badge bg-warning text-dark" style={{ fontSize: "11px" }}>
                                            🔁 Duplicates: {bulkResult.duplicates.length}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <p style={{ fontSize: "13px" }}><strong>Message:</strong> {bulkResult?.message}</p>

                            {bulkResult?.notes?.length > 0 && (
                                <>
                                    <h6 className="mt-3" style={{ fontSize: "14px" }}>📝 Notes</h6>
                                    <ListGroup variant="flush" className="border rounded">
                                        {bulkResult.notes.map((note, i) => (
                                            <ListGroup.Item key={i} style={{ fontSize: "12px" }}>{note}</ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                </>
                            )}

                            {bulkResult?.errors?.length > 0 && (
                                <>
                                    <h6 className="mt-3 text-danger" style={{ fontSize: "14px" }}>❌ Errors</h6>
                                    <div
                                        className="border rounded p-2"
                                        style={{ maxHeight: "200px", overflowY: "auto" }}
                                    >
                                        <ListGroup variant="flush">
                                            {bulkResult?.errors?.map((err, i) => (
                                                <ListGroup.Item key={i} className="text-danger" style={{ fontSize: "12px" }}>
                                                    {err}
                                                </ListGroup.Item>
                                            ))}
                                        </ListGroup>
                                    </div>
                                </>
                            )}

                            {bulkResult?.duplicates?.length > 0 && (
                                <>
                                    <h6 className="mt-3 text-warning" style={{ fontSize: "14px" }}>🔁 Duplicates</h6>
                                    <div
                                        className="border rounded p-2"
                                        style={{ maxHeight: "200px", overflowY: "auto" }}
                                    >
                                        <ListGroup variant="flush">
                                            {bulkResult.duplicates.map((dup, i) => (
                                                <ListGroup.Item key={i} className="text-warning" style={{ fontSize: "12px" }}>
                                                    {dup}
                                                </ListGroup.Item>
                                            ))}
                                        </ListGroup>
                                    </div>
                                </>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowResultModal(false)} size="sm" style={{ fontSize: "13px" }}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}

            </div>
        </React.Fragment>
    );
};

export default MenuPricing;